import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import PrivateRoutes from "../../utils/PrivateRoute";

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";

export default function RootLayout() {
  const { token } = useSelector(({ auth }) => auth);

  return (
    <PrivateRoutes auth={token}>
      <div class="grid h-svh grid-cols-[auto_1fr] bg-black">
        <Sidebar className="" />
        <div class="grid min-h-0 grid-rows-[auto_1fr]">
          <Navbar className="" />
          <main class="overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </PrivateRoutes>
  );
}
